<template>
  <v-card title="打卡统计">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="dkyf"
                  placeholder="打卡月份"
                  type="month"
                  valueFormat="yyyyMM"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
              <!-- <v-form-item>
                <v-button type="warning" icon="export" @click="exportExcel()"
                  ><span>导出</span></v-button
                >
              </v-form-item> -->
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-toolbar export></vxe-toolbar>
    <vxe-table
      size="mini"
      border
      height="408"
      :data="tableData"
      :expand-config="{
        accordion: true,
        lazy: true,
        loadMethod: loadContentMethod,
      }"
      :export-config="{}"
    >
      <vxe-table-column
        type="seq"
        width="60"
        title="序号"
        header-align="center"
        align="center"
      ></vxe-table-column>
      <vxe-table-column
        type="expand"
        width="80"
        header-align="center"
        align="center"
      >
        <template v-slot:content="{ row }">
          <button @click="exportData">导出数据</button>
          <vxe-grid
            ref="xGrid"
            class="mytable-style"
            :columns="row.childCols"
            :data="row.childData"
            :export-config="{}"
          >
            <template v-slot:cz="{ row }">
              <span>
                <a class="link" @click="mx(row)"
                  ><v-icon type="search"></v-icon
                ></a>
              </span>
            </template>
          </vxe-grid>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="khbh"
        title="客户编号"
        header-align="center"
        align="left"
      ></vxe-table-column>
      <vxe-table-column
        field="khmc"
        title="客户名称"
        header-align="center"
        align="left"
      ></vxe-table-column>
      <vxe-table-column
        field="dkdcnt"
        title="打卡点数量"
        header-align="center"
        align="right"
      ></vxe-table-column>
      <vxe-table-column
        field="dkrycnt"
        title="打卡人员数量"
        header-align="center"
        align="right"
      ></vxe-table-column>
      <vxe-table-column
        field="zcdkcnt"
        title="正常打卡次数"
        header-align="center"
        align="right"        
      >
      </vxe-table-column>
      <vxe-table-column
        field="fzcdkcnt"
        title="非正常打卡次数"
        header-align="center"
        align="right"
      >
      </vxe-table-column>
    </vxe-table>
  </v-card>
</template>
<script>
import { milliFormat } from "../../../static/js/milli_format.js";
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      dkyf: dateFormat("YYYYmm", new Date()),
      rse_dkyf: "",
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      if (this.dkyf == "") {
        this.$message["error"]("请选择报销月份！");
        return;
      }
      this.$axios
        .get("api/system/dktj/get-dktj1-list?dkyf=" + this.dkyf)
        .then((res) => {
          this.tableData = res.data.data;
        });
    },
    // exportExcel() {
    //   if (this.dkyf == "") {
    //     this.$message["error"]("请选择打卡月份！");
    //     return;
    //   }
    //   let a = document.createElement("a");
    //   a.href = "api/system/bxtj/月度汇总?dkyf=" + this.dkyf;
    //   a.click();
    // },
    mx(row) {
      xadmin.open("员工打卡明细", "/rydkmx?gh=" + row.gh + "&xm="+row.xm+"&dkyf=" + this.dkyf);
    },
    loadContentMethod({ row }) {
      return new Promise((resolve) => {
        const childCols = [
          { type: "seq", title: "序号", headerAlign:"center",align: "center" },
          { field: "gh", title: "工号", headerAlign:"center",align: "left" },
          { field: "xm", title: "姓名", headerAlign:"center",align: "left" },
          { field: "dkts", title: "打卡天数", headerAlign:"center",align: "right" },
          { field: "zcdk", title: "正常打卡次数", headerAlign:"center",align: "right" },
          { field: "fzcdk", title: "非正常打卡次数", headerAlign:"center",align: "right" },
          { field: "sbdk", title: "上班打卡次数", headerAlign:"center",align: "right" },
          { field: "xbdk", title: "下班打卡次数", headerAlign:"center",align: "right" },          
          {
            field: "cz",
            title: "明细",
            align: "center",
            headerAlign: "center",
            slots: { default: "cz" },
          },
        ];
        row.childCols = childCols;
        this.$axios
          .get(
            "api/system/dktj/get-dktj2-list?khbh=" +
              row.khbh +
              "&dkyf=" +
              + this.dkyf
          )
          .then((res) => {
            row.childData = res.data.data;
            resolve();
          });
      });
    },
    exportData() {
      debugger;
      this.$refs.xGrid.exportData({
        type: 'csv',
        filename: '人员统计',
      });
    },
    // footerMethod({ columns, data }) {
    //   return [
    //     columns.map((column, columnIndex) => {
    //       if (columnIndex === 0) {
    //         return "合计";
    //       }
    //       if (["bxrs"].includes(column.property)) {
    //         let sum = 0;
    //         data.forEach((item) => {
    //           sum += item.bxrs;
    //         });
    //         return sum;
    //       } else if (["bxje"].includes(column.property)) {
    //         let sum = 0;
    //         data.forEach((item) => {
    //           sum += item.bxje;
    //         });
    //         return milliFormat(sum);
    //       }
    //       return null;
    //     }),
    //   ];
    // },
    // formatterAmount(row) {
    //   // return milliFormat(row.cellValue.toString());
    // },
    // headerCellClassName({ column, columnIndex }) {
    //   if (column.property === "xm") {
    //     return "col-blue";
    //   }
    // },
  },
};
function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  return fmt;
}
</script>


<style>
.mytable-style .vxe-table .vxe-table--header {
  background-color: rgb(170, 168, 168);
  color: aliceblue;
}
.vxe-footer--row {
  background-color: #ffbf00;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/view/kqdk/dktj.vue